import React from 'react'
import ValentineSiteTakeoverBackground from 'takeovers/valentineTakeover/components/ValentineSiteTakeoverBackground'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import moment from 'moment'

const valentineTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'valentine',
  startDate: moment('2025-02-12T08:00:00+1100'),
  endDate: moment('2025-02-15T02:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: {
    type: 'inclusive',
    list: new Set(['SG', 'HK', 'AE', 'ZA', 'IN']),
  },
  imageId: 'gidua9dchhephstwu3jp',
  primaryColour: '#F84916',
  palette: 'default',
  offerTypes: new Set(['hotel']),
  verticals: new Set(['home', 'hotel']),
  heroSection: {
    title: 'Happy Valentine\'s Day',
    subtitle: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
    verticals: new Set(['home']),
  },
  backgroundElement: ValentineSiteTakeoverBackground,
  offerPage: {
    bannerContent: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
  },
  siteWide: {
    banner: {
      description: <>Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</>,
    },
  },
  searchPage: {
    bannerContent: <VerticalSpacer gap={2}>
      <Heading variant="heading2">Happy Valentine's Day</Heading>
      <BodyText variant="large">Use code <b>LOVEISINTHEAIR</b> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025</BodyText>
    </VerticalSpacer>,
  },

}

export default valentineTakeoverConfig
